import { render } from "./ApplicationForm.vue?vue&type=template&id=f81e93e0"
import script from "./ApplicationForm.vue?vue&type=script&lang=ts"
export * from "./ApplicationForm.vue?vue&type=script&lang=ts"
script.render = render

export default script